import React, { useState } from 'react';
import {
  nullFn,
  normalizeDate,
  getFirstDayOfMonth,
  getFormattedMonth,
  addMonth,
  addYear,
  setMonth,
} from '../../utils';
import { SingleCalendarProps } from '../../types';
import CalendarDaysOfWeek from './CalendarDayOfWeek';
import CalendarMonth from './CalendarMonth';
import CalendarHeader from './CalendarHeader';
import { Calendar } from './Calendar';

export default function SingleCalendar({
  id = undefined,
  value = new Date(),
  maxValue = undefined,
  minValue = undefined,
  onChange = nullFn,
  className = undefined,
  style = undefined,
  locale = 'en-US',
  selectionType = 'single',
  selectedRange = undefined,
}: SingleCalendarProps): JSX.Element {
  const [currentMonth, setCurrentMonth] = useState(
    getFirstDayOfMonth(normalizeDate(value)),
  );
  const formattedMonth = getFormattedMonth(currentMonth, locale);
  const currentYear = currentMonth.getFullYear();

  const handleOnNextClick = () => {
    setCurrentMonth(addMonth(1, currentMonth));
  };

  const handleOnPrevClick = () => {
    setCurrentMonth(addMonth(-1, currentMonth));
  };

  const handleOnYearChange = (year: number) => {
    setCurrentMonth(addYear(year, currentMonth));
  };

  const handleOnMonthChange = (month: number) => {
    setCurrentMonth(setMonth(month, currentMonth));
  };

  return (
    <section id={id} className={className} style={style}>
      <CalendarHeader
        formattedMonth={formattedMonth}
        currentYear={currentYear}
        locale={locale}
        onNextMonthClick={handleOnNextClick}
        onPrevMonthClick={handleOnPrevClick}
        onYearChange={handleOnYearChange}
        onMonthChange={handleOnMonthChange}
      />
      <table
        className='border-collapse w-full box-border table table-fixed'
        cellSpacing='0'
      >
        <CalendarDaysOfWeek locale={locale} />
        <Calendar
          selectionType={selectionType}
          currentRange={selectedRange}
          focusedDate={normalizeDate(value)}
          selectedRange={selectedRange}
        >
          <CalendarMonth
            firstOfMonth={currentMonth}
            value={value}
            minValue={minValue}
            maxValue={maxValue}
            onChange={onChange}
          />
        </Calendar>
      </table>
    </section>
  );
}
